import useGlobalConfig from './useGlobalConfig'
import { useHead } from '#imports'

type HtfScript = {
  type: 'text/javascript'
  src: string
  tagPriority: number
}

export const useHtfScripts = () => {
  const { htfFeatures } = useGlobalConfig()

  const getHtfScripts = () => {
    if (!htfFeatures.value) {
      return null
    }

    return htfFeatures.value.reduce<HtfScript[]>(
      (acc, { active, scriptIsBoot, scriptSrc }) => {
        if (active && scriptIsBoot && scriptSrc) {
          acc.push({
            type: 'text/javascript',
            src: `https://htfcdn.madeleine.com/${scriptSrc}`,
            // Must stay parser-blocking (no defer/async): the HTF boot script
            // relies on running before first paint (anti-flicker mask, DOM
            // scanning). Deferring it breaks its lifecycle (ECOM-2626).
            // Numeric (not 'critical' alias): unhead 2 changed `critical` from
            // offset -80 to -8 and introduced an explicit weight of 50 for sync
            // scripts, so 'critical' now resolves to 42 — after preconnect (20).
            // 15 keeps HTF between <title> (10) and preconnect (20), matching prod.
            tagPriority: 15,
          })
        }
        return acc
      },
      [],
    )
  }

  const load = () => {
    if (import.meta.client) {
      return
    }

    const scripts = getHtfScripts()
    if (!scripts?.length) {
      return
    }

    useHead({ script: scripts })
  }

  return { load }
}
